import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
import api from '../../axiosConfig';
import domain from '../../constants/config.js';
import { aesEncrypt, getOSType } from './../../utils/Common.js';

const apiDomain = domain.LOGIN_API_BASE_URL;

export const OtpAuthenticate = createAsyncThunk(
  'OtpAuthenticateList/OtpAuthenticate',
  async (requestData) => {
    try {
        
        const encryptedToken = {}; //aesEncrypt(requestData.mobile_number);
        console.log('Encrypted token=========:', encryptedToken);

        const headers = {
            'X-Source-Type': getOSType(),
            'Authorization': encryptedToken,
            'Content-Type': 'application/json', // optional, but good to include
        };

        console.log('headers =========:', headers);
        const apiUrl = `${apiDomain}v1/authentication-code`;
        const response = await api.post(apiUrl,requestData,{headers});
        console.log("API OtpAuthenticate Response:", response.data);

      return response.data;
    } catch (error) {
      console.error("API Error in OtpAuthenticate:", error);
      throw error;
    }
  }
);

export const getOtpMobileToken = createAsyncThunk(
  'OtpAuthenticateList/getOtpMobileToken',
  async (requestData) => {
    try {
        
        console.log('getOtpMobileToken =========:', requestData);
        const apiUrl = `${apiDomain}v3/get-mobile-token`;
        const response = await api.post(apiUrl,requestData);
        console.log("API OtpAuthenticate Response:", response.data);

      return response.data;
    } catch (error) {
      console.error("API Error in getOtpMobileToken:", error);
      throw error;
    }
  }
);

export const OtpAuthenticateNew = createAsyncThunk(
  'OtpAuthenticateList/OtpAuthenticateNew',
  async (requestData) => {
    try {
        console.log('OtpAuthenticateNew =========:', requestData);
        const apiUrl = `${apiDomain}v4/auth-code`;
        const response = await api.post(apiUrl,requestData);
        console.log("API OtpAuthenticate Response:", response.data);

      return response.data;
    } catch (error) {
      console.error("API Error in OtpAuthenticate:", error);
      throw error;
    }
  }
);

export const OtpVerify = createAsyncThunk(
    'OtpAuthenticateList/OtpVerify',
    async (requestData) => {
      try {
  
        const apiUrl = `${apiDomain}v5/verification-code/verify`;
        const response = await api.post(apiUrl,requestData);
        console.log("API OtpVerify Response:", response.data);
  
        return response.data;
      } catch (error) {
        console.error("API Error in OtpVerify:", error);
        throw error;
      }
    }
  );


const OtpAuthenticateSlice = createSlice({

  name: 'OtpAuthenticateList',
  initialState: {
    apiResponse: [],
    loading: false,
    apiErrorMsg: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(OtpAuthenticate.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
      })
      .addCase(OtpAuthenticate.fulfilled, (state, action) => {
        state.loading = false;
        state.apiResponse = action.payload; //API call completes → fulfilled sets list = response.data
        console.log("Reducer OtpAuthenticate apiResponse",state.apiResponse);
      })
      .addCase(OtpAuthenticate.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      })
      .addCase(getOtpMobileToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOtpMobileToken.fulfilled, (state, action) => {
        state.loading = false;
        state.apiResponse = action.payload;
        console.log("Reducer getOtpMobileToken apiResponse",state.apiResponse);
      })
      .addCase(getOtpMobileToken.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      })
      .addCase(OtpAuthenticateNew.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
        // console.log("priceDetailsSlice",state.loading);
      })
      .addCase(OtpAuthenticateNew.fulfilled, (state, action) => {
        state.loading = false;
        state.apiResponse = action.payload; //API call completes → fulfilled sets list = response.data
        console.log("Reducer OtpAuthenticateNew apiResponse",state.apiResponse);
      })
      .addCase(OtpAuthenticateNew.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      })
      .addCase(OtpVerify.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
      })
      .addCase(OtpVerify.fulfilled, (state, action) => {
        state.loading = false;
        state.apiResponse = action.payload; //API call completes → fulfilled sets list = response.data
        console.log("Reducer OtpVerify apiResponse",state.apiResponse);
      })
      .addCase(OtpVerify.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      });
  },
});

export default OtpAuthenticateSlice.reducer;
